<template>
    <div ref="BaiduMapView" v-if="!hasBmView" style="width: 100%; height: 100%"></div>
</template>

<script>
let infoBox = null

export default {
    name: "BaiduMap",
    data() {
        return {
            hasBmView: false,
        }
    },
    props: {
        ak: {
            type: String,
            default: ''
        },
        mapStyle: {
            type: Object,
            default: ()=> ({
                styleId: ''
            })
        },
        center: {
            type: Array,
            default: ()=> {
                return [114.031761, 22.542826]
            }
        },
        zoom: {
            type: Number,
            default: 11
        },
        infoBox: {
            type: Object,
            default: ()=>({
                visible: false,
                boxStyle: {},
                closeIconMargin: '',
            })
        },
        markers: {
            type: Array
        }
    },
    mounted() {
        const {getMapScript, initMap} = this
        getMapScript()
            .then(initMap)
    },
    watch: {
        markers: function (newVal) {
            const allOverlay = this.map.getOverlays();

            //先清除所有点位
            if (typeof this.map.getOverlays === 'undefined') {
                return
            }

            for(let j = 0;j<allOverlay.length;j++) {
                //删除标记点
                this.map.removeOverlay(allOverlay[j]);

                if ( allOverlay[j].toString() === "Marker" ) {
                    this.map.removeOverlay(allOverlay[j]);
                    allOverlay[j].removeEventListener('click')
                    allOverlay[j].removeEventListener('mouseover')
                    allOverlay[j].removeEventListener('mouseout')

                    allOverlay[j].timer && clearInterval(allOverlay[j].timer)
                }
            }

            newVal.forEach(item=>{
                this.addMarker(item)
            })
        },
        infoBox: function (newVal) {
            this.renderInfoBox(newVal)
        }
    },
    methods: {
        /**
         * 加载百度地图
         */
        getMapScript: function () {
            if (!global.BMapGL) {
                const ak = this.ak
                global.BMapGL = {}
                global.BMapGL._preloader = new Promise((resolve, reject) => {
                    global._initBaiduMap = function () {
                        resolve(global.BMapGL)
                        global.document.body.removeChild($script)
                        global.BMapGL._preloader = null
                        global._initBaiduMap = null
                    }
                    const $script = document.createElement('script')
                    global.document.body.appendChild($script)
                    $script.src = `https://api.map.baidu.com/api?type=webgl&v=1.0&ak=${ak}&callback=_initBaiduMap`
                })
                return global.BMapGL._preloader
            } else if (!global.BMapGL._preloader) {
                return Promise.resolve(global.BMapGL)
            } else {
                return global.BMapGL._preloader
            }
        },
        /**
         * 初始化地图
         */
        initMap: function (BMap) {
            //加载InfoBox组件
            const infoBoxScript = document.createElement('script')
            infoBoxScript.type = 'text/javascript'
            infoBoxScript.src = `https://api.map.baidu.com/library/InfoBox/1.2/src/InfoBox_min.js`
            document.head.appendChild(infoBoxScript)

            this.BMap = BMap
            global.BMap = BMap

            if (this.map) {
                return
            }
            let $el = this.$refs.BaiduMapView

            for (let $node of this.$slots.default || []) {
                if ($node.componentOptions && $node.componentOptions.tag === 'bm-view') {
                    this.hasBmView = true
                    $el = $node.elm
                }
            }


            // 创建Map实例
            const map = new BMap.Map($el, {
                // minZoom:3,
                // maxZoom:18,
                coordsType: 5 // coordsType指定输入输出的坐标类型，3为gcj02坐标，5为bd0ll坐标，默认为5。
                              // 指定完成后API将以指定的坐标类型处理您传入的坐标
            });          // 创建地图实例
            window.map = this.map = map

            const point = new BMap.Point(this.center[0], this.center[1]);  // 创建点坐标
            map.centerAndZoom(point, this.zoom);                 // 初始化地图，设置中心点坐标和地图级别

            //开启鼠标滚轮缩放
            map.enableScrollWheelZoom(true)

            map.setMapStyleV2(this.mapStyle);

            //添加地图点击事件
            map.addEventListener('click', handleClick);
            function handleClick (e) {
                console.log('点击的经纬度：' + e.latlng.lng + ', ' + e.latlng.lat);
                const mercator = map.lnglatToMercator(e.latlng.lng, e.latlng.lat);
                console.log('点的墨卡托坐标：' + mercator[0] + ', ' + mercator[1]);
            }

            let that = this
            map.addEventListener("zoomend",
                function() {
                    const currentZoom = map.getZoom()
                    that.$emit('zoomChange', currentZoom)
                }
            );

            //地图初始化之后发射ready方法
            this.$emit('ready', {BMap, map})
        },
        /**
         * 地图上增加标记点
         */
        addMarker: function (Marker = {}) {
            const events = Marker.events||{}
            const position = Marker.position || {}
            const point = new BMap.Point(position.lng, position.lat)

            let MyIcon = null
            if (typeof Marker.icon == 'object') {
                const icon = Marker.icon

                MyIcon = new BMap.Icon(icon.image || null, new BMap.Size(icon.size.width, icon.size.height))
            }

            const marker = new BMap.Marker(point, {icon: MyIcon})

            Object.keys(events).forEach(event => {
                marker.addEventListener(event, e=> {
                    if (typeof events[event] === 'function') {
                        events[event].apply(null, [{marker, e}])
                    }
                })
            })

            this.map.addOverlay(marker)

            if (Marker.animation) {
                marker.setZIndex(9999)

                //呼吸动画
                const breathAnimation = function() {
                    setTimeout(function() {
                        const icon = Marker.icon
                        const iconImage = icon.image

                        marker.setIcon(new BMap.Icon(iconImage, new BMap.Size(icon.size.width* 1.5, icon.size.height* 1.5)))

                        setTimeout(function() {

                            marker.setIcon(new BMap.Icon(iconImage, new BMap.Size(icon.size.width* 2, icon.size.height* 2)))

                            setTimeout(function() {

                                marker.setIcon(new BMap.Icon(iconImage, new BMap.Size(icon.size.width* 1.5, icon.size.height* 1.5)))

                                setTimeout(function() {

                                    marker.setIcon(new BMap.Icon(iconImage, new BMap.Size(icon.size.width* 1, icon.size.height* 1)))


                                }, 500)


                            }, 500)

                        }, 500)

                    }, 500)

                }

                breathAnimation()
                marker.timer = setInterval(breathAnimation, 3000)
            }

            if ( typeof marker.label === 'object' && marker.label.text ) {
                this.addLabel(position, marker.label.text.replace('+','') )

            }
        },
        /**
         * 添加文本标注
         */
        addLabel: function(position={lng: '', lat: ''}, content = "label") {
            const point = new BMap.Point(position.lng, position.lat)

            const label = new BMap.Label(content, {       // 创建文本标注
                position: point,                          // 设置标注的地理位置
                offset: new BMap.Size(-20, -20)           // 设置标注的偏移量
            })
            label.setStyle({                              // 设置label的样式
                color: '#ee6666',
                fontSize: '30px',
                border: '2px solid #ee6666',
                background:'rgba(238,102,102,.2)',
                'border-radius':'30px',
                padding:'0 12px'
            })

            this.map.addOverlay(label);
        },
        /**
         * 地图上增加设备标记点
         */
        renderDeviceMarker: function (device = {}) {
            const device_id = device.device_id;

            if ( typeof this.markers[device_id] !== 'undefined' ) {
                delete (this.markers[device_id])
            }

            const position = device.position || []
            const events = device.events||{}
            const point = new BMapGL.Point(position[0], position[1])

            let MyIcon = null
            if (typeof device.icon == 'object') {
                const icon = device.icon
                MyIcon = new BMapGL.Icon(icon.image || null, new BMapGL.Size(icon.size.width, icon.size.height))
            }

            const marker = new BMapGL.Marker(point, {icon: MyIcon})

            Object.keys(events).forEach(event => {
                marker.addEventListener(event, events[event])
            })


            this.map.addOverlay(marker)

            this.markers[device_id] = marker
        },
        /**
         * 地址逆解析,获取当前市
         * @param point 坐标 {lng: '', lat:''}
         */
        getLocation: function (point= {}) {
            return new Promise((resolve, reject) => {
                const myGeo = new BMapGL.Geocoder();
                const po = new BMapGL.Point(point.lng, point.lat)
                let city = ''
                myGeo.getLocation(po, function (res) {
                    const addComp = res.addressComponents || {};

                    city = addComp.city || ''

                    resolve(city)
                })
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/BaiduMap.vue